<template>
<div class="InteractionEventDetails">
    <el-form ref="form" :model="form" label-width="110px" label-position="left">
        <div class="item">
            <header><p>基本信息</p></header>
                <el-form-item label="活动名称">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="活动简介">
                    <el-input type="textarea" v-model="form.subtitle"></el-input>
                </el-form-item>
                <el-form-item label="活动封面">
                <img class="fm" :src="form.coveratturlid.furl" :alt="form.title">
                </el-form-item>
                <el-form-item label="活动时间段">
                    <el-input v-model="form.begintime"></el-input>
                </el-form-item>
                <el-form-item label="活动详情">
                    <div class="ueditorBox">
                        <uEditor :content="form.eventdesp" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
                    </div>
                </el-form-item>
        </div>
        <div class="item">
            <header>
                <p>项目设置</p>
            </header>
            <el-form-item label="参与方式">
                <el-input v-model="form.jointypetext"></el-input>
            </el-form-item>
        </div>
        <div class="sign-in item">
            <header>
                <p>互动信息</p>
            </header>
            <el-form-item :label="item.isnotnull == 1 ? '必填':'不必填'" v-for="(item, index) in form.eventformlist" :key="index">
                <el-input v-model="item.colname"></el-input>                     
                <div class="list" v-if="item.coltype == 5 || item.coltype == 6 || item.coltype == 7 || item.coltype == 8">
                    <p style="margin-top:20px">选项列表</p>
                    <el-input v-model="spiltItem.value" v-for="(spiltItem, i) in item.optionsinfo" :key=i></el-input>
                </div>
                
            </el-form-item>
        </div>
        <div class="set-up item">
            <header>
                <p>活动设置</p>
            </header> 
            <el-form-item label="传播隐私设置">
                <el-input v-model="form.sharetype"></el-input>
            </el-form-item>
            <el-form-item label="留言设置">
                <el-input v-model="form.commentpritype"></el-input>
            </el-form-item>
            <el-form-item label="参与有奖励">
                <div class="min">
                    <span>奖励总金额</span>
                    <el-input v-model="form.joinawardtotalmoney"></el-input>
                    <span>奖励数量</span>
                    <el-input v-model="form.joinawardtotalcount"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="分享有奖励">
                <div class="min">
                    <span>单个奖励金额</span>
                    <el-input v-model="form.shareawardtotalcount"></el-input>
                    <span>奖励数量</span>
                    <el-input v-model="form.shareawardsinglemoney"></el-input>
                </div>
            </el-form-item>
        </div>
    </el-form>
</div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import UEditor from 'base/uEditor/uEditor'
import { getInteractEventDetail } from 'api/operateToolApi'
export default {
    name: 'InteractionEventDetails',
    data() {
        return {
            eventinnerid: this.$route.query.eventinnerid, // 活动ID
            form: {
                    title:'', // 活动标题
                    subtitle:'', //  活动简介
                    coveratturlid:'', //  活动Logo图对象
                    begintime:'', //  活动开始时间
                    endtime:'', //  活动结束时间
                    eventdesp:'', //  活动详情
                    eventplace:'', //  活动地点
                    jointype: '', // 参与方式
                    status:'', //  活动状态 0, 待发布 10, 进行中  11, 暂停中  30, 已完成  100,已取消 
                    //互动信息
                    eventformlist: [    //  签到表单list
                        {
                            colindex:'', //   序号 
                            colinnerid:'', //   表单InnerID
                            colname:'', //   字段名称
                            coltype:'', //   字段类型：1 单行文本框 2 数字文本框 3 日期选择框 4 邮箱输入框 5 多行文本框 6 单选按钮框 7 多选按钮框 8 下拉选择框
                            placeholder:'', //   字段提示语
                            optionsinfo:'', //   下拉选项表：多个以逗号隔开
                            ispublic:'', //   是否公开 
                            isnotnull:'', //   是否必填
                        }
                    ], 

                    //活动设置
                    sharetype:'', //   传播隐私设置 1所有人均可转发  2只有发布者可以转发
                    isopencomment:'', //   留言设置  0否 1是
                    isjoinaward:'', //   是否参与奖励 0否 1是 
                    joinawardtotalmoney:'', //   参与奖励总金额 
                    joinawardtotalcount:'', //   参与奖励总个数 
                    isshareaward:'', //   是否分享奖励 0否 1是 
                    shareawardtotalcount:'', //   分享奖励总个数 
                    shareawardsinglemoney:'', //   分享奖励单个金额" 
                },
        }
    },
    mounted() {
       this.setLoading(true)
        getInteractEventDetail({
            data: {eventinnerid: this.eventinnerid},
            success: data => {
                this.setLoading(false)
                this.form = data.data
                this.form.begintime = `${this.form.begintime} 至 ${this.form.endtime}`
                 // 活动详情渲染
                this.$refs.uEditor.init(this.form.eventdesp)

                for (let i = 0; i < this.form.eventformlist.length; i++) {

                    if (this.form.eventformlist[i].coltype == 6 || this.form.eventformlist[i].coltype == 7 || this.form.eventformlist[i].coltype == 8) {
                        
                        let data = [],
                            optionsinfo = this.form.eventformlist[i].optionsinfo,
                            optionsinfoItem = optionsinfo.split(',')

                        for (let j = 0; j < optionsinfoItem.length; j++) {
                            data.push({value: optionsinfoItem[j]})
                        }

                        this.form.eventformlist[i].optionsinfo = data
                    }
                }
                // this.form.eventformlist.unshift({ //  表单list
                //     colinnerid: '', // 表单InnerID
                //     colname: '姓名', // 字段名称 
                //     colindex: '', // 序号 
                //     coltype: 1, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                //     placeholder: '', // 字段提示语
                //     optionsinfo: "", // 下拉选项表：表单提交时 多个以逗号隔开
                //     isnotnull: 1, // 是否必填" 
                //     ispublic: 0,   // 是否公开
                //     },
                //     { //  表单list
                //         colinnerid: '', // 表单InnerID
                //         colname: '手机', // 字段名称 
                //         colindex: '', // 序号 
                //         coltype: 1, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                //         placeholder: '', // 字段提示语
                //         optionsinfo: "", // 下拉选项表：表单提交时 多个以逗号隔开
                //         isnotnull: 1, // 是否必填" 
                //         ispublic: 0,   // 是否公开
                //     }
                // )
                this.$nextTick(() => {
                    this.form = JSON.parse(JSON.stringify(this.form))
                })
        
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
    },
    methods: {
        // 详情信息 
        getUEditorContent(content) {
            this.form.eventdesp = content
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        UEditor
    }
}
</script>


<style lang="scss" type="text/scss">
.InteractionEventDetails {
    .item {
        margin-bottom: 20px;
        border-bottom: solid 1px #eee;
    }
    .ue_btn {
        display: none;
    }
    .el-textarea {
        width: 400px;
        height: 80px;

        .el-input {
            height: 100%;   
        }
    }
    .el-input {
        max-width: 400px;

        input {
            width: 100%;
        }
    }
    .time {
        .el-input {
            max-width: 268px;
            margin-bottom: 20px;
            max-width: 268px;
        }
    }

    .sign-in {
        .el-input {
            display: block;
            max-width: 128px;
        }

        .list {
            .el-input {
                margin-top: 20px;
                display: block;
                max-width: 277px;
            }   
        }

    }
    .set-up {
        .min {
            .el-input {
                margin: 0 20px;
                max-width: 116px;
            }   
        }
 
    }

    .fm {
        display: block;
        width: 318px;
        height: 178px;
        border-radius: 4px;
    }
    header {
        height: 60px;
        p {
            padding-left: 20px;
            font-size: 16px;
            color: #333;
            border-left: solid 2px #409eff 
        }
    }
}
</style>